import * as yup from 'yup';
import { CONTACT_METHOD_TYPE } from './RatingContactFollowUp/constants';

export const validationSchemaCode = yup
  .string()
  .required('This field is required')
  .matches(/^\d{6}$/, 'Please enter a 6-digit code');

export const validationSchemaContactMethod = yup
  .string()
  .oneOf(Object.values(CONTACT_METHOD_TYPE))
  .required('Please choose a contact method');

export const validationSchemaPhone = yup
  .string()
  .min(14, 'Phone number must be 10 digits')
  .max(14, 'Phone number must be 10 digits')
  .required('Please enter your phone number');

export const validationSchemaName = yup
  .string()
  .min(2, 'Name must be at least 2 characters')
  .required('Please enter your name');

export const validationSchemaQuestion = yup
  .string()
  .required('Please enter a question with at least a few words');

export const validationSchemaEmail = yup
  .string()
  .email('Please enter a valid email address')
  .required();
